(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name crewing.controller:CrewingCtrl
     *
     * @description
     *
     */
    angular
        .module('crewing')
        .controller('CrewingCtrl', CrewingCtrl);

    function CrewingCtrl(CrewingHelper,
                         CommonLogicService,
                         RemoteService,
                         CrewingSelectionHelper,
                         $timeout,
                         $scope,
                         CommonMasterData,
                         EventManagerService,
                         SlideInPanelService,
                         MessageService,
                         PopupManager,
                         crewingConstants,
                         CrewingRequest,
                         CrewingAdaptor,
                         TabService,
                         StorageServices,
                         applicationConstants,
                         hotkeys,
						              $window,
                         $stateParams,
                         $filter) {
        var vm = this;
        vm.rightPanelName = 'crewing.right.panel';
        vm.view = "CREWING";
        vm.crewList = "";
        vm.model = {
        	crewTypes: [],
        	AircraftTypes: [],
        	crewBaseTypes: [],
        	CrewGroups: [],
        	crewDTOs: [],
        	crewCategory: [],
          mgtPositions:[],
        	allNationalities: [],
          crewBatchList: [],
        	allLanaguages : [],
        	crewTypeMasterCodes: [],
        	crewOperTypes:[],
          crewType: '',
          crewIds: '',
          crewSchedule: null,
          crewList : [],
          searchParam: '',
          filterSearchParam: '',
          openPairingParam: '',
          openPairings: null,
          isSearchPanelOpen: false,
          viewMode: 'W',
          cutPasteRequest: null,
          copyPasteRequest: null,
          cutPastTrainingFlags: null,
          copyPastTrainingFlags: null,
          cutPastCrewList: null,
          swapFlags: {
              isUserConfirm: false,
              isIgnoreExpiry: false
          },
          timeZoneText: '',
          currentTime: null,
          getBlockDetailsParam: null,
          isSchedulePublish: false,
          isMoreRecordsAvailable: true,
          isShowAllCrewsForBlockActive: false,
          isFilterActive: false,
          recordsPerPage: 30,
          startIndex: 0,
          blockParams:'',
          isMultipleCopy: false
        };
      vm.ofcEventSaveModel = {
        isStartLocationRequred:false,
        isEndLocationRequred:false,
        isShowPortal:false,
        isShowPortalEnabled:false,
        isShowPortalVisible:false,
        isEditMode : false,
        crewScheduleBlockId : '',
        crewProfileId: '',
        patternId : '',
        crewId: '',
        event: null,
        selectedDates:[],
        startDate: {
          value: "",
          isDisable: true
        },
        startTime: {
          value: '00:00',
          isDisable: false
        },
        endDate: {
          value:  "",
          isDisable: false
        },
        endTime: {
          value: '00:00',
          isDisable: false
        },
        startLocation: {
          value: null,
          isDisable: false
        },
        endLocation: {
          value: null,
          isDisable: false
        },
        eventOccurringFlight: {
          value: null,
          isDisable: false
        },
        dutyPeriod: {
          value: '00:00',
          isDisable: true
        },
        aircraftType: {
          value: {
            modelNumber:null
          },
          isDisable: false
        },
        isExcludeFromPayment: {
          value: false,
          isDisable: false
        },
        isAirportStandby: {
          value: false,
          isDisable: false
        },
        isRequest: {
          value: false,
          isDisable: false
        },
        isCallFromDayOff: {
          value: false,
          isDisable: false
        },
        isOffC: {
          value: false,
          isDisable: false
        },
        isObsFlight: {
          value: false,
          isDisable: false
        },
        isHideinCrewPortal: {
          value: false,
          isDisable: false
        },
        isOutStationOff: {
          value: false,
          isDisable: false
        },
        remark: {
          value: null,
          isDisable: false
        }
      }

        hotkeys.add({
            combo: 'ctrl+z',
            description: 'Undo operation',
            callback: function(event, hotkey) {
                onFireUndoEvent();
            }
        });

        EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.VIEW_MODE_CHANGE, viewModeChangeListener);

        EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.REFRESH, onRefreshCrewScheduleListener);

        EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.PUBLISH, onToolbarPublishListener);

        EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.SHOW_CREW_FILTER, onShowCrewFilterListener);

        EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);

        EventManagerService.registerEventListener(EventManagerService.EVENT.CREWING.OPEN_MEMO, openMemoListener);

        EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.UPDATE_SCHEDULE_FOR_CREWS, onUpdateCrewSchedule);

        EventManagerService.registerEventListener(EventManagerService.EVENT.PANEL.RELOAD_PANEL_DATA, onReloadData);

        EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.SHOW_IN_CREW_PORTAL, onShowInCrewPortal);

        EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.HIDE_IN_CREW_PORTAL, onHideInCrewPortal);

        EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.SHOW_IN_PORTAL, showInCrewPortalListener);

        EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.SHOW_VIOLATIONS, onShowViolationReasons);

        EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.UNDO, onFireUndoEvent);


      //initial calling functions
      getAirports();


        angular.element($window).bind('focus', function () {
	        if(localStorage.getItem("crewList") != undefined  &&
	        	  vm.crewList == localStorage.getItem("crewList")){
	            updateSelectedCrew([vm.crewList]);
	            localStorage.removeItem("crewList");
	        }
        });

        if (!angular.isUndefined(sessionStorage["CrewProfileBlockID"]) &&
        		!angular.isUndefined(sessionStorage["SearchParam"]) &&
        		!angular.isUndefined(sessionStorage["CrewID"]) &&
        		sessionStorage["CrewProfileBlockID"] != "undefined" &&
        		sessionStorage["SearchParam"] != "undefined" &&
        		sessionStorage["CrewID"]) {

        	CrewingHelper.getBlockAssignedCrew(sessionStorage["CrewProfileBlockID"],function (crewIds) {

        		/*vm.model.openPairingParam = CrewingRequest.openPairingRequest(angular.fromJson(sessionStorage["SearchParam"]));
        		getOpenPairings(vm.model.openPairingParam, true);*/


        		vm.model.searchParam = CrewingRequest.crewScheduleRequest(angular.fromJson(sessionStorage["SearchParam"]));

              if(vm.model.searchParam.crewIds != ""){
                vm.model.crewIds = vm.model.searchParam.crewIds.split(",");
              }else{
                vm.model.crewIds = [];
              }

        		if (crewIds.length == 0)
        			crewIds = sessionStorage["CrewID"];

        		if (crewIds.length > 0) {
        			var param = angular.copy(angular.fromJson(sessionStorage["SearchParam"]));
        			param.crewIds = crewIds;
        			param.startPosition = 1;
        			param.crewType = '';

        			vm.model.crewSchedule = [];

                    vm.model.openPairingParam = CrewingRequest.openPairingRequest(param);
                    getOpenPairings(vm.model.openPairingParam, false);

                    vm.model.searchParam = CrewingRequest.crewScheduleRequest(param);

                    doCrewScheduleSearch(vm.model.searchParam);

                    //getTrackingTimeZone();

        		} else {
        			CrewingHelper.moveCrewToTopAndRemoveOthers(sessionStorage["CrewID"], angular.fromJson(sessionStorage["SearchParam"]));
        			vm.model.crewSchedule = CrewingHelper.getCrewScheduleData();
        		}

        		CrewingHelper.scrollToTopCrewSchedule();
        		getTrackingTimeZone();

    			vm.model.blockParams = angular.fromJson(sessionStorage["ParamsBlock"]);

    			sessionStorage.setItem("ParamsBlock", undefined);
        		sessionStorage.setItem("CrewProfileBlockID", undefined);
        		sessionStorage.setItem("SearchParam", undefined);
        		sessionStorage.setItem("CrewID", undefined);

        		sessionStorage.removeItem("CrewProfileBlockID");
        		sessionStorage.removeItem("SearchParam");
        		sessionStorage.removeItem("CrewID");
        		sessionStorage.removeItem("ParamsBlock");
        	},

        	function (error) {
        		MessageService.error(error);
        		EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);

        		sessionStorage.setItem("CrewProfileBlockID", undefined);
        		sessionStorage.setItem("SearchParam", undefined);
        		sessionStorage.setItem("CrewID", undefined);

        		sessionStorage.removeItem("CrewProfileBlockID");
        		sessionStorage.removeItem("SearchParam");
        		sessionStorage.removeItem("CrewID");
        	});
        }

        vm.getSearchPanelData = function () {
            getCrewTypes();
            getAircraftList();
            getCrewBaseTypes();
            getCrewGroups();
            getCrewPositions();
            getCrewTypeMasterCodes();
            getNationalityList();
            getLanguageList();
            getCrewOperTypes();
            getCrewBatchList();
          getManagementCrewPositionList();
            var rowHeight = 50;
            vm.model.recordsPerPage = Math.ceil(screen.height / rowHeight) * 3;
        };

        vm.onSearchSchedule = function (searchParam) {
            if(searchParam.crewIds != ""){
                vm.model.crewIds = searchParam.crewIds.split(",");
            }else{
                vm.model.crewIds = [];
            }
        	document.querySelector('.right-section').scrollTop = 0;
        	document.querySelector('.right-section').scrollLeft = 0;

            vm.model.crewSchedule = [];

            /*close all open panels*/
            SlideInPanelService.closeAllPanels();

            /*Reset Append Mode use for showAll Crews for Block*/
            vm.model.isShowAllCrewsForBlockActive = false;

            /*Reset Filter Mode*/
            vm.model.isFilterActive = false;

            vm.model.openPairingParam = CrewingRequest.openPairingRequest(searchParam);
            getOpenPairings(vm.model.openPairingParam, false);

            vm.model.searchParam = CrewingRequest.crewScheduleRequest(searchParam);

            doCrewScheduleSearch(vm.model.searchParam);

            getTrackingTimeZone();
        };

        vm.onBlockDelete = function (blocks) {
            deleteBlock(blocks, true);
        };


        vm.loadCrewListByType = function(crewType){
            var param={};
            param.crewType = crewType;
            param.active = true;
            CommonMasterData.loadCrewList(param,
                function (response) {
                    vm.model.crewList = CrewingHelper.adaptCrewList(response);
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.CREW_LIST_UPDATED);
                },
                function () {
                    console.log('Crew list retrieval error');
                }
            );

        };

        vm.onSwapDuty = function (firstDuty, secondDuty) {
            var duties = {
                'firstDuty': firstDuty,
                'secondDuty': secondDuty
            };
            CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
                var appParamsEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
                if(appParamsEnable && vm.model.isSchedulePublish){
                    var details = {
                        title: 'Confirmation',
                        messages: [MessageService.MESSAGES.CREWING.CREW_PORTAL_HIDE]
                    };
                    PopupManager.openModal('CONFIRM_DIALOG', details, confirmShowInCrewPortal);
                }else{
                    confirmShowInCrewPortal('NO');
                }
            });

            function confirmShowInCrewPortal(pass){
                var isShowInCrewPortal = true;
                if(pass=='YES'){
                    isShowInCrewPortal = false;
                }
                performSwapOperation(duties,
                    vm.model.swapFlags.isUserConfirm,
                    vm.model.swapFlags.isIgnoreExpiry, isShowInCrewPortal);
            }

        };

        vm.onPastBlock = function (pasteActionParam) {
            var checkGenderWarnings = true;
            doPasteBlock(pasteActionParam, checkGenderWarnings);
        };

        vm.onAssignOpenPairing = function (params) {
            if (CrewingHelper.isDistributionCheckApplicable('FLIGHT')) {
                CrewingHelper.checkDistributionWarnings(params.crewTypeMasterCode, params.pattern.patternId, params.crewProfileId, false, assignPairing, params, onCancel);
            } else {
                assignPairing(params);
            }

            function onCancel() {
                repositionSelectedOpenParing(params.pattern);
            }
        };

        vm.reloadOpenParings = function () {
            getOpenPairings(vm.model.openPairingParam, true);
        };

        vm.assignDirectEvent = function (param, eventType) {
            var stDate, endDate;
            if (param.isMultiple) {
                stDate = param.startDate;
                endDate = param.endDate;
            } else {
                stDate = endDate = param.dateClicked;
            }

            CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
                var appParamsEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
                if(appParamsEnable && vm.model.isSchedulePublish){
                    var details = {
                        title: 'Confirmation',
                        messages: [MessageService.MESSAGES.CREWING.CREW_PORTAL_HIDE],
                        close : 'CLOSE'
                    };
                    PopupManager.openModal('CONFIRM_DIALOG', details, confirmAssignDirectAction);
                }else{
                    confirmAssignDirectAction('NO');
                }
            });

            function confirmAssignDirectAction(pass){
                var isShowInCrewPortal = true;
                if(pass=='YES'){
                    isShowInCrewPortal = false;
                }else if(pass =='CLOSE'){
                	return;
                }

              if (param.isOnProbation == 'Y') {
                var details = {
                  title: 'Confirmation',
                  messages: [MessageService.MESSAGES.CREWING.CREW_PROBATION_OVERRIDE,
                    "Crew Details:",
                    "Id:" + param.crewId,
                    "Name: " + param.crewName],
                  close: 'CLOSE'
                };
                PopupManager.openModal('CONFIRM_DIALOG', details, confirmAssignDirectAction);
              } else {
                confirmAssignDirectAction('NO');
                // vm.onDirectAction({ param: crewInfo, type: crewingConstants.EVENT_TYPES.sickLeave });
              }

              function confirmAssignDirectAction(pass) {
                if (pass == 'CLOSE' || pass == undefined) {
                  return;
                }
                var forceAssignLeave = false;
                if (pass == 'YES') {
                  forceAssignLeave = true;
                }

                CrewingHelper.assignDirectEvent(
                    param.crewProfileId,
                    eventType,
                    stDate,
                    endDate,
                    false,
                    isShowInCrewPortal,
                    function (data) {
                        if (data.success) {
                            switch (eventType) {
                                case crewingConstants.EVENT_TYPES.blockDays :
                                {
                                    MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_BLOCK_DAYS_SUCCESS);
                                    break;
                                }
                                case crewingConstants.EVENT_TYPES.off :
                                {
                                    MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_OFF_SUCCESS);
                                    break;
                                }
                                case crewingConstants.EVENT_TYPES.sickLeave :
                                {
                                    MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_SICK_LEAVE_SUCCESS);
                                    break;
                                }
                                case crewingConstants.EVENT_TYPES.annualLeave :
                                {
                                    MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_ANNUAL_LEAVE_SUCCESS);
                                    break;
                                }case crewingConstants.EVENT_TYPES.cnt :
                                {
                                    MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_CNT_SUCCESS);
                                    break;
                                } default :
                                {
                                  MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_LEAVE_SUCCESS);
                                  break;
                                }
                            }
                            updateSelectedCrew([param.crewId]);
                        } else if (!!data.regulationMap) {
                          var data1= CrewingAdaptor.assignEventAdaptor(data)
                          var regulationDetailParam = {
                            regulationMap: data1.adaptedRegulationMap,
                            onAcceptPassBackParam: data1
                          };
                          PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam, onCloseRegulationPopupForDirectEvents);
                        }

                      function onCloseRegulationPopupForDirectEvents(data) {
                        if (!!data) {
                          // var isContinueIllegal = false;
                          var isUserConfirm = true;
                          // while(data.selectedDates[0] !== data.regulationOccuredDate ){
                          //   data.assignEventRequestParam.selectedDates.shift();
                          // }
                          CrewingHelper.assignDirectEvent(
                            param.crewProfileId,
                            eventType,
                            stDate,
                            endDate,
                            false,
                            isShowInCrewPortal,
                            function (data) {
                              if (data.success) {
                                updateSelectedCrew([param.crewId]);
                              }
                            },
                            function (msg) {
                              MessageService.error(msg);
                            },
                            param.isCustomSelectedDates,
                            param.customSelectedDates,
                            forceAssignLeave,
                            isUserConfirm,
                            param.selectedBase
                          );
                        }
                      }
                    },
                    function (error) {
                        MessageService.error(error);
                  },
                  param.isCustomSelectedDates,
                  param.customSelectedDates,
                  forceAssignLeave,
                  false,   // isUserConfirm
                  param.selectedBase
                );
                    }
            }

        };

      vm.onEvaluateTrainings = function (param) {
        PopupManager.openModal('EVALUATE_TRAININGS', param);
      };


        vm.onSendSms = function (param) {
        	if(param.isForDay) {
        		param.messageContent = CrewingHelper.getDutiesForCrew(param.crew.crewId, param.day.date, 3, null);
        	} else {
    			param.messageContent = CrewingHelper.getDutiesForCrew(param.crewInfo.crewId, param.checkInDate, 2, param.crewScheduleBlockId);
        	}
            PopupManager.openModal('SMS', param);
        };

        vm.onAssignPairing = function (params) {
        	CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {


        		vm.scrollTopPosition = angular.element(".right-section").scrollTop();
        		vm.scrollLeftPosition = angular.element(".right-section").scrollLeft();

        		var appParamsEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');

        		params.day = params.day[0];
        		params.crew = params.crew[0];
        		params.showInCrewPortalParams = {
        				isVisible: appParamsEnable,
        				isEnabled: appParamsEnable && vm.model.isSchedulePublish,
        				value: !vm.model.isSchedulePublish ? false : true
        		};

            for(var i=0; i < vm.model.crewDTOs.length; i++) {
               if(params.crew.crewDTO.crewProfileId == vm.model.crewDTOs[i].crewProfileId){
                  params.flyingDuration=vm.model.crewDTOs[i].flyingDuration;
                  params.targetDuration=vm.model.crewDTOs[i].targetDuration;
               }
            }
                params.showTargetHoursPopup = false;
        		PopupManager.openModalInDiv(params.container, 'ASSIGN_PARING', params, onCloseAssignPairingModal);

        		function onCloseAssignPairingModal(assignParingResponse) {
        			angular.element(".right-section").scrollTop(vm.scrollTopPosition);
        			angular.element(".right-section").scrollLeft(vm.scrollLeftPosition);
        			assignPairingResponseActions(assignParingResponse);
        		}
        	});

        };

        vm.onAssignTraining = function (params) {
            CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
            	vm.scrollTopPosition = angular.element(".right-section").scrollTop();
            	vm.scrollLeftPosition = angular.element(".right-section").scrollLeft();
                var appParamsEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
                params.day = params.day[0];
                params.crew = params.crew[0];
                params.showInCrewPortalParams = {
                    isVisible: appParamsEnable,
                    isEnabled: appParamsEnable && vm.model.isSchedulePublish,
                    value: !vm.model.isSchedulePublish ? false : true
                };
                PopupManager.openModalInDiv(params.container, 'ASSIGN_TRAINING', params, onAssignTrainingClose);

                function onAssignTrainingClose(updatedCredIds) {
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
                   /* angular.element(".right-section").scrollTop(vm.scrollTopPosition);
                    angular.element(".right-section").scrollLeft(vm.scrollLeftPosition);*/
                    if (!!updatedCredIds && updatedCredIds.length > 0) {
                        updateSelectedCrew(updatedCredIds,callListUpdateEvent);
                    }
                    else{
                    	callListUpdateEvent();
                    }

                    function callListUpdateEvent(){
                    	angular.element(".right-section").scrollTop(vm.scrollTopPosition);
            			angular.element(".right-section").scrollLeft(vm.scrollLeftPosition);
                    }
                }
            });
        };

        vm.onAssignEvent = function (params) {
            CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
                var appParamsEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
                var param = {};
                param.day = params.day[0];
                param.crew = params.crew[0];
                param.container = params.container;
                param.showInCrewPortalParams = {
                    isVisible: appParamsEnable,
                    isEnabled: appParamsEnable && vm.model.isSchedulePublish,
                    value: !vm.model.isSchedulePublish ? false : true
                };
                addEditEvent(param);
            });
        };

        vm.onSendAlert = function (param) {
            if (vm.model.isSchedulePublish) {
                PopupManager.openModal('ALERT', param, onSendAlertClose);
            }
            else {
                MessageService.warning(MessageService.MESSAGES.CREWING.SCHEDULE_NOT_PUBLISH);
            }
        };

        vm.onEditBlock = function (params) {
            vm.model.getBlockDetailsParam = params;
            getBlockDetail(params);
        };

        vm.onAddMemo = function (params) {
            var param = {};
            param.day = params.day.date;
            param.crewProfileId = params.crew.crewDTO.crewProfileId;
            param.crewId = params.crew.crewId;

            param.memo = CrewingHelper.getMemoForDayAndCrew(param.crewId, param.day);
            PopupManager.openModal('ADD_EDIT_MEMO', param, onAddMemoClose);
        };

        vm.onShowRegulations = function (params) {
//            var crewScheduleBlock = CrewingHelper.getCrewScheduleBlockId(params && params.block && params.block.events);
            var crewScheduleBlockId = params.block.crewScheduleBlockId;
            var crewProfileId = params.crew.crewDTO.crewProfileId;

            CrewingHelper.getRegulation(crewProfileId, crewScheduleBlockId,
                function (response) {
                    var regulationDetailParam = {
                        regulationMap: response.adaptedRegulationMap,
                        onAcceptPassBackParam: null,
                        hideFooterButtons: true
                    };
                    PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam);
                },
                function (msg) {
                    MessageService.error(msg);
                }
            );
        };

        vm.onShowPaxMsgDet = function (params) {
          var crewScheduleBlockId = params.block.crewScheduleBlockId;
          var crewProfileId = params.crew.crewDTO.crewProfileId;

          CrewingHelper.getPaxMessageDet(crewProfileId, crewScheduleBlockId,
        		  function (response) {
              		var paxParam = {
              				data: response.paxMsgList
              		};
              		PopupManager.openModal('PAX_MSG_DETAILS', paxParam);
          		},
              function (msg) {
                  MessageService.error(msg);
              }
          );
      };

      vm.onAssignDirectOfcEventInRosters = function (params,type) {
        CrewingHelper.getEvents(
          function (events) {
            vm.model.eventTypes = events;
            vm.model.event = _.find(vm.model.eventTypes['DUTY'] , function (obj) { return obj.eventCode === "OFC"; });
            vm.ofcEventSaveModel.event = vm.model.event;
            performUiChanges(params);
            updateEvent();
          },
          function (msg) {
            MessageService.error(msg)
          },
          null
        );

      };

      function performUiChanges(params) {
        if (!!vm.model.event) {
          vm.ofcEventSaveModel.startTime.value='00:00';
          vm.ofcEventSaveModel.endTime.value='00:00';
          vm.ofcEventSaveModel.aircraftType.value=null;
          vm.ofcEventSaveModel.endLocation.value=null;
          vm.ofcEventSaveModel.eventOccurringFlight.value=null;
          vm.ofcEventSaveModel.isAirportStandby.value=false;
          vm.ofcEventSaveModel.isCallFromDayOff.value=false;
          vm.ofcEventSaveModel.isObsFlight.value=false;
          vm.ofcEventSaveModel.isHideinCrewPortal.value=vm.ofcEventSaveModel.event.hideinCrewPortal;
          vm.ofcEventSaveModel.isOffC.value=false;
          vm.ofcEventSaveModel.isExcludeFromPayment.value=vm.ofcEventSaveModel.event.excludeFromPayment;
          vm.ofcEventSaveModel.isOutStationOff.value=false;
          vm.ofcEventSaveModel.startLocation.value=null;
          vm.ofcEventSaveModel.isRequest.value=false;
          vm.ofcEventSaveModel.remark.value=null;
          vm.ofcEventSaveModel.dutyPeriod.value='00:00';
          vm.ofcEventSaveModel.isStartLocationRequred=angular.isUndefined(vm.ofcEventSaveModel.event.startLocRequired)?false:vm.ofcEventSaveModel.event.startLocRequired;
          vm.ofcEventSaveModel.isEndLocationRequred = angular.isUndefined(vm.ofcEventSaveModel.event.endLocRequired)?false:vm.ofcEventSaveModel.event.endLocRequired;


          vm.ofcEventSaveModel.startTime.value = vm.ofcEventSaveModel.event.startTime;
          vm.ofcEventSaveModel.endTime.value = vm.ofcEventSaveModel.event.endTime;
          if(vm.ofcEventSaveModel.event.eventCategoryCode === 'DUTY'){
            var selectedDate = moment(params.dateClicked.date).format('DD/MM/YYYY');
            vm.ofcEventSaveModel.startDate.value = selectedDate;
          }
          vm.ofcEventSaveModel.crewProfileId=params.crewProfileId;
          vm.ofcEventSaveModel.startDate.value = params.startDate;
          vm.ofcEventSaveModel.endDate.value = params.endDate;
          if(params.customSelectedDates  === undefined || params.customSelectedDates === null){
            setCustomDates(params.startDate,params.endDate);
          }else{
            vm.ofcEventSaveModel.selectedDates = params.customSelectedDates;
          }
          enableOrDisable(vm.ofcEventSaveModel.event);
          calculateDutyHours()
        }
      }

      function calculateDutyHours() {
        vm.ofcEventSaveModel.dutyPeriod.value = CommonLogicService.calculateDutyHours(
          vm.ofcEventSaveModel.startDate.value,
          vm.ofcEventSaveModel.startTime.value,
          vm.ofcEventSaveModel.startDate.value,//to consder one day
          vm.ofcEventSaveModel.endTime.value,
          vm.ofcEventSaveModel.event.dutyHrsPercent);
      }

      function setCustomDates(startDate,endDate){
        var customDates = [startDate,endDate];
        vm.ofcEventSaveModel.selectedDates = customDates;
      }
      function enableOrDisable(event){
        if (!!event) {
          if(event.eventCategoryCode === 'DUTY' && (event.eventCode === 'DTR' || event.eventCode === 'MDT'
            || event.eventCode === 'MTG' ||event.eventCode === 'OFC' || event.eventCode === 'GCA'
            || event.eventCode ==='MED' || event.eventCode === 'OBS' || event.eventCode === 'SOD' ||event.eventCode ==='CKF')){
            vm.ofcEventSaveModel.eventOccurringFlight.isDisable =true;
            vm.ofcEventSaveModel.isAirportStandby.isDisable=true;
            vm.ofcEventSaveModel.isRequest.isDisable=true;
            vm.ofcEventSaveModel.isOutStationOff.isDisable=true;
            vm.ofcEventSaveModel.isOffC.isDisable = true;
          }

          vm.ofcEventSaveModel.isStartLocationRequred=angular.isUndefined(event.startLocRequired) ? false : event.startLocRequired;
          vm.ofcEventSaveModel.isEndLocationRequred = angular.isUndefined(event.endLocRequired) ? false : event.endLocRequired;

          vm.ofcEventSaveModel.endLocation.isDisable = !event.endLocRequired;
          vm.ofcEventSaveModel.startLocation.isDisable = !event.startLocRequired;
          vm.ofcEventSaveModel.isExcludeFromPayment.isDisable = !event.excludeFromPayment;
          vm.ofcEventSaveModel.aircraftType.isDisable = (!event.acTypeRequired||(vm.ofcEventSaveModel.isEditMode && vm.ofcEventSaveModel.event.eventCode =='SBY' && !!vm.ofcEventSaveModel.aircraftType !=null ));

          if(event.eventCategoryCode === 'DUTY' && (event.eventCode === 'GCA' || event.eventCode ==='OFC' || event.eventCode ==='SOD')){
            vm.ofcEventSaveModel.startLocation.value = _.find(vm.model.airportList,{airPortCode:event.startLocation});
            vm.ofcEventSaveModel.endLocation.value = _.find(vm.model.airportList,{airPortCode:event.endLocation});
          }
        }
      }

      function updateEvent(){
        var isContinueIllegal = true;
        var isUserConfirm = false;

        var param = vm.ofcEventSaveModel;

        var selectedCrews = CrewingSelectionHelper.getSelectedCrews();
        var isOnProbation = selectedCrews[0].crewDTO.isOnProbation;
        var crewId = selectedCrews[0].crewDTO.crewId;
        var firstName = selectedCrews[0].crewDTO.firstName;
        var lastName = selectedCrews[0].crewDTO.lastName;
        console.log(isOnProbation);
        if (isOnProbation=='Y'){
          var details = {
            title: 'Confirmation',
            messages: [MessageService.MESSAGES.CREWING.CREW_PROBATION_OVERRIDE,
              "Crew Details:",
              "Id:" + crewId,
              "Name: " + firstName+" "+lastName],
            close: 'CLOSE'
          };
          PopupManager.openModal('CONFIRM_DIALOG', details, updateEventPopupListener);


        }else {
          CrewingHelper.assignDirectOfcEvent( vm.ofcEventSaveModel,isContinueIllegal,isUserConfirm,
            function (assignEventData) {
              var params = {
                assignEventResponse : assignEventData,
                assignEventRequestParam :vm.ofcEventSaveModel,
                isEditMode : vm.ofcEventSaveModel.isEditMode
              };
              EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
              if (!!params && !!params.assignEventResponse) {
                if (params.assignEventResponse.success) {
                  if(params.isEditMode){
                    MessageService.success(MessageService.MESSAGES.CREWING.UPDATE_SUCCESS);
                  }else{
                    MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_EVENT_SUCCESS);
                  }
                  updateSelectedCrew([crewId],callListUpdateEvent);
                } else if (!!params.assignEventResponse.adaptedRegulationMap) {
                  var regulationDetailParam = {
                    regulationMap: params.assignEventResponse.adaptedRegulationMap,
                    onAcceptPassBackParam: params
                  };
                  console.log("Show regulations",regulationDetailParam)
                  PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam, onCloseRegulationPopupForEvents);
                }
                function callListUpdateEvent(){
                  angular.element(".right-section").scrollTop(vm.scrollTopPosition);
                  angular.element(".right-section").scrollLeft(vm.scrollLeftPosition);
                }
              }

              function onCloseRegulationPopupForEvents(params) {
                if (!!params) {
                  var isContinueIllegal = false;
                  var isUserConfirm = true;
                  while(params.assignEventRequestParam.selectedDates[0] !== params.assignEventResponse.regulationOccuredDate ){
                    params.assignEventRequestParam.selectedDates.shift();
                  }
                  CrewingHelper.assignDirectOfcEvent(params.assignEventRequestParam, isContinueIllegal, isUserConfirm,
                    function (assignEventData) {
                      if (assignEventData.success) {
                        MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_EVENT_SUCCESS);
                        updateSelectedCrew([crewId],callListUpdateEvent);
                      }
                      function callListUpdateEvent(){
                        angular.element(".right-section").scrollTop(vm.scrollTopPosition);
                        angular.element(".right-section").scrollLeft(vm.scrollLeftPosition);
                      }
                    },
                    function (msg) {
                      MessageService.error(msg);
                    }
                  );
                }
              }


            },
            function (msg) {
              MessageService.error(msg.msg[0]);
            }
          );
        }      close: 'CLOSE'

      }
      function getAirports() {
        CommonMasterData.getAirportList(
          function (airports) {
            vm.model.airportList = airports;
          },
          function (msg) {
            MessageService.error(msg);
          }
        );
      }
        vm.onShowHistory = function (params) {
            var crewProfileId = params.crew.crewDTO.crewProfileId;
            var selectedDate = params.day.date;

            CrewingHelper.getHistory(crewProfileId, selectedDate,
                function (historyResponse) {
                    var param = {
                        history: historyResponse
                    };
                    PopupManager.openModal('HISTORY_DETAILS', param);
                },
                function (msg) {
                    MessageService.error(msg);
                }
            );
        };

        vm.onShowAllCrewsInSchedule = function (params) {
            var crewId = CrewingHelper.getCrewIdFromAdaptedBlock(params.block);
            var crewScheduleBlock = CrewingHelper.getCrewScheduleBlockId(params && params.block && params.block.events);
            var crewProfileBlockId = crewScheduleBlock.blockId;
            var paramsBlock = params.block;

            sessionStorage.setItem("ParamsBlock", angular.toJson(paramsBlock));
            sessionStorage.setItem("CrewProfileBlockID", crewProfileBlockId);
            sessionStorage.setItem("CrewID", crewId);
            sessionStorage.setItem("SearchParam", angular.toJson(vm.model.searchParam));

            window.open(window.location.href);
            window.focus();
        };

        vm.onEmailCrewSchedule = function (params) {
            var crewProfileId = params.crews[0].crewDTO.crewProfileId;
            CrewingHelper.emailCrewSchedule(
                crewProfileId,
                vm.model.searchParam.fromDate,
                vm.model.searchParam.toDate,
                function (date) {
                    if (date) {
                        MessageService.success(MessageService.MESSAGES.CREWING.SCHEDULE_EMAIL_SUCCESS);
                    }
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        };

        vm.onShowCrewSchedule = function (params) {
            var crew = params[0];
            vm.crewList = crew.crewId;
            var tabName = 'crewSchedule';
            StorageServices.setTabData(tabName, 'crewingParams', {
                crewId: crew.crewId,
                fromDate: vm.model.searchParam.fromDate,
                toDate: vm.model.searchParam.toDate,
                fleetExperince: vm.model.searchParam.acModel,
                crewBase: vm.model.searchParam.base,
                crewIdCol : CrewingHelper.getCrewIds(crew.crewId)
            });
            TabService.gotoTab(tabName, {
                crewId: crew.crewId
            });
        };

        vm.onEditPairing = function (params) {
            var _editPairingParams = {
                crewId: params.crew.crewId,
                patternId: params.block.patternId,
                patternStartDate: params.block.patternStartDate,
                patternEndDate: params.block.patternEndDate,
                patternName: params.block.patternName,
                crewBase: ''
            };

            var navigateToManagePairing = function (paramToSend) {
                var tabName = 'managePairing';
                StorageServices.setTabData(tabName, 'editPairingParams', paramToSend);
                TabService.gotoTab(tabName, {
                    patternId: paramToSend.patternId
                });
            };

            _editPairingParams.crewBase = !!vm.model.searchParam.base ? vm.model.searchParam.base : applicationConstants.SETTINGS.CREW_BASE_AIRPORT;
            navigateToManagePairing(_editPairingParams);
        };

        vm.onStartPositionChange = function (params) {
            vm.model.searchParam.startPosition = parseInt(params);
            vm.model.crewSchedule = [];
            doCrewScheduleSearch(vm.model.searchParam);
        };

        vm.onCancelFiltering = function () {
            vm.model.filterSearchParam = null;
            vm.model.isFilterActive = false;
            vm.model.searchParam.crewIds = '';
            doCrewScheduleSearch(vm.model.searchParam);
        };


        /**
         * Handle navigation from Duty Sheet Screen
         * @param crewId
         **/

         function handleNevigation(){
        	 if (!!$stateParams.mode || !!$stateParams.time) {
                 var tabLocalData = StorageServices.getTabData('crewing');
                 if (!!tabLocalData && !!tabLocalData.crewingParams) {
                	 var searchParam = tabLocalData.crewingParams;
                	 searchParam.fromDate = tabLocalData.crewingParams.fromDate;
                	 searchParam.toDate = tabLocalData.crewingParams.toDate;
                	 searchParam.crewIDs = tabLocalData.crewingParams.crewIds;
                	 searchCrewingDetails(searchParam);
                 }
             }
         };

         function searchCrewingDetails(searchParam){
        	 vm.model.crewSchedule = [];
             SlideInPanelService.closeAllPanels();
             vm.model.isShowAllCrewsForBlockActive = false;
             vm.model.isFilterActive = false;
             vm.model.openPairingParam = CrewingRequest.openPairingRequest(searchParam);
             getOpenPairings(vm.model.openPairingParam, false);
             vm.model.searchParam = CrewingRequest.crewScheduleRequest(searchParam);
             doCrewScheduleSearch(vm.model.searchParam, false, true);
             isCrewSchedulePublishedForCrewProfileId();
             getTrackingTimeZone();
         }

        function onShowViolationReasons() {
            var selection = CrewingSelectionHelper.getSelectedBlocks();
            var details = {};
            details.crewProfileID = selection[0].events[0].crewInfo.crewProfileId;
            details.pairingID = selection[0].patternId;
            PopupManager.openModal('SHOW_IN_VIOLATIONS', details, function(){});
        }

        function showInCrewPortalListener() {
            CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
                vm.isBlockViewFlagEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
                if(vm.isBlockViewFlagEnable){
                    if(!!vm.model.crewSchedule){
                        var selectedCrews = CrewingSelectionHelper.getSelectedCrews();
                        var message = MessageService.MESSAGES.CREWING.SHOW_ALL_IN_CREW_PORTAL;
                        var details = {
                            title: 'Confirmation',
                            messages: [message],
                            allCrew: (selectedCrews.length >0)?true:false
                        };
                        PopupManager.openModal('CONFIRM_SHOW_IN_PORTAL', details, showPortalForAllConfirm);
                    }else{
                        MessageService.warning(MessageService.MESSAGES.CREWING.CREW_SCHEDULE_NOT_LOADED);
                    }

                }
            });

            function showPortalForAllConfirm(pass){
                var selected=[];
                if(angular.isUndefined(pass)){
                    return false;
                }else{
                    if(pass.allCrew){
                        selected = CrewingSelectionHelper.getSelectedCrews();
                    }else{
                        selected = null;
                    }

                    CrewingHelper.updateVisibilityFlagCrews(selected, vm.model.searchParam, function(){
                        if(!!selected){
                            var crewIds = _.pluck(selected, 'crewId');
                            updateSelectedCrew(crewIds);
                        }else{
                            doCrewScheduleSearch(vm.model.searchParam)
                        }

                    });
                }
            }
        }

        function resetSwapFlags() {
            vm.model.swapFlags.isUserConfirm = false;
            vm.model.swapFlags.isIgnoreExpiry = false;
        }

        function assignPairing(params) {
            CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
                var appParamsEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
                if(appParamsEnable && vm.model.isSchedulePublish){
                    var details = {
                        title: 'Confirmation',
                        messages: [MessageService.MESSAGES.CREWING.CREW_PORTAL_HIDE]
                    };
                    PopupManager.openModal('CONFIRM_DIALOG', details, confirmAssignDirectAction);
                }else{
                    confirmAssignDirectAction('NO');
                }

            });

            function confirmAssignDirectAction(pass) {
                var isShowInCrewPortal = false;
                if (pass == 'YES') {
                    isShowInCrewPortal = true;
                }
                CrewingHelper.assignPattern(
                    params.crewProfileId,
                    params.pattern,
                    params.isRequest,
                    params.isCallFromDayOff,
                    params.isObsFlight,
                    params.isHideinCrewPortal,
                    true,
                    false,
                    isShowInCrewPortal,
                    null,
                    params.isTargetHoursValid,
                    params.sbyCallOutDateTime,
                    null,
                    null,
                    null,
                    function success(assignParingResponse) {

                        var param = {
                            regulationDetails: assignParingResponse,
                            crewProfileId: params.crewProfileId,
                            crewTypeMasterCode: params.crewTypeMasterCode,
                            pattern: params.pattern,
                            isRequest: params.isRequest,
                            isCallFromDayOff: params.isCallFromDayOff,
                            isObsFlight: params.isObsFlight,
                            isHideinCrewPortal: params.isHideinCrewPortal,
                            isShowCrewPortal: isShowInCrewPortal,
                            isTargetHoursValid : params.isTargetHoursValid

                        };
                        assignPairingResponseActions(param);
                    },
                    function fail(msg) {
                        MessageService.error(msg);
                    });
            }
        }


        function doPasteBlock(pasteActionParam, isCheckGenderWarnings) {
            var crewProfileId = pasteActionParam.pasteCrewProfileId || pasteActionParam.crewProfileId;

            if (!!isCheckGenderWarnings && CrewingHelper.isDistributionCheckApplicable(pasteActionParam.patternType)) {
                CrewingHelper.checkDistributionWarnings(pasteActionParam.crewTypeMasterCode, pasteActionParam.patternId, crewProfileId, false, doPasteBlock, pasteActionParam);
            } else {

                CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
                    var appParamsEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
                    if(appParamsEnable && vm.model.isSchedulePublish){
                        var details = {
                            title: 'Confirmation',
                            messages: [MessageService.MESSAGES.CREWING.CREW_PORTAL_HIDE]
                        };
                        PopupManager.openModal('CONFIRM_DIALOG', details, doCutCopyPaste);
                    }else{
                        doCutCopyPaste('NO');
                    }

                });

            }

            function doCutCopyPaste(pass){
                var isShowInPortal = true;
                if(pass=='YES'){
                    isShowInPortal = false;
                }
                pasteActionParam.isShowInPortal = isShowInPortal;
                if (pasteActionParam.pasteType == 'CUT') {
                    vm.model.isBlockDrop = !!pasteActionParam.isDropped; //Identify Block Drag and drop
                    performPasteForCutOperation(pasteActionParam);
                } else if (pasteActionParam.pasteType == 'COPY') {
                    performPasteForCopyOperation(pasteActionParam);
                } else if (pasteActionParam.pasteType == 'COPY_MULTIPLE') {
                    performPasteForMultipleCopyOperation(pasteActionParam, 0)
                }
            }
        }

        function deleteBlock(blocks, isCheckGenderWarnings) {
            //ignore check when multiple blocks selected
            if (!!isCheckGenderWarnings && CrewingHelper.isDistributionCheckApplicable( blocks[0].patternType)) {
                CrewingHelper.checkDistributionWarnings(blocks[0].crewInfo.crewTypeMasterCode, blocks[0].blockId, blocks[0].crewInfo.crewProfileId, true, deleteBlock, blocks);
            } else {
				blocks["isComplementFilled"] = true;
				var UnAssignBlockRequestCrewDTOs = [];
        for(var i=0; i < blocks.length; i++) {
           for(var j=0; j < vm.model.crewDTOs.length; j++) {
            var crewProfileId = vm.model.crewDTOs[j].crewProfileId;
            var crewExists = checkIfCrewExists(crewProfileId, UnAssignBlockRequestCrewDTOs);
            if(blocks[i].crewInfo.crewProfileId == vm.model.crewDTOs[j].crewProfileId && !crewExists){
              UnAssignBlockRequestCrewDTOs.push(vm.model.crewDTOs[j]);
            }
          }
        }
                CrewingHelper.unAssignBlock(blocks,UnAssignBlockRequestCrewDTOs,
                    function (data) {
                        updateSelectedCrew(getCrewIdsFromBlocks(blocks));
                        getOpenPairings(vm.model.openPairingParam, true);
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.RESET_SELECTED_CREW_AND_DAYS);
                        MessageService.success(MessageService.MESSAGES.CREWING.DUTY_REMOVE_SUCCESS);
                        if (data.otherHubSyncResponsesCSBMap && Object.keys(data.otherHubSyncResponsesCSBMap).length > 0){
                          getSyncResponses(data.otherHubSyncResponsesCSBMap);
                        }
                      if(data.sendCrewNotification){
                        var param ={};
                        param.message=data.message;
                        param.profileId= data.crewProfileId;
                        param.user = data.user;
                        param.telephone = data.telephone;
                        param.crewSchdChangeId = data.crewSchdChangeId;
                        if (data.disableSendYes) {
                          param.disableSendYes = "false";
                        }
                        else {
                          param.disableSendYes = "true";
                        }
                        param.pushNotificationMessage=data.pushNotificationMessage;
                        PopupManager.openModal('SEND_CHANGE_NOTIFICATION',param);
                      }
                    },
                    function () {
                        MessageService.error(MessageService.MESSAGES.CREWING.DUTY_REMOVE_FAILED);
                    }
                );
            }
        }

        function checkIfCrewExists(crewProfileId, crewArray) {
          for (var i = 0; i < crewArray.length; i++) {
            if (crewArray[i].crewProfileId === crewProfileId) {
              return true;
            }
          }
          return false;
        }
        function getSyncResponses(data){
          var result = {};
          for (var csbID in data) {
              if (data.hasOwnProperty(csbID)) {
                  var CSB = data[csbID];

                  for (var tenant in CSB) {
                      if (CSB.hasOwnProperty(tenant)) {
                          if (!result.hasOwnProperty(tenant)) {
                              result[tenant] = true;
                          }
                          result[tenant] = result[tenant] && CSB[tenant];
                      }
                  }
              }
          }
          var syncResponses = [];
          for (var key in result) {
            if (result.hasOwnProperty(key)) {

              if (result[key]) {
                MessageService.success('Tenant: ' + key + ', Status: SUCCESS');
              } else {
                MessageService.warning('Tenant: ' + key + ', Status: FAILED');
              }

            }
          }
          return syncResponses;
        }
        function addEditEvent(param) {
          vm.scrollTopPosition = angular.element(".right-section").scrollTop();
    		  vm.scrollLeftPosition = angular.element(".right-section").scrollLeft();

            PopupManager.openModalInDiv(param.container, 'ASSIGN_EVENT', param, onAssignEventClose);

            function onAssignEventClose(params) {
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);

                if (!!params && !!params.assignEventResponse) {
                    if (params.assignEventResponse.success) {
                        updateSelectedCrew([params.assignEventRequestParam.crewId],callListUpdateEvent);
//                    	updateSelectedCrew([params.assignEventRequestParam.crewId]);
                        MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_EVENT_SUCCESS);

                      if(params.assignEventResponse.sendCrewNotification === "Y"){
                        var param ={};
                        param.message=params.assignEventResponse.message;
                        param.profileId= params.assignEventResponse.crewProfileId;
                        param.user = params.assignEventResponse.user;
                        param.telephone = params.assignEventResponse.telephone;
                        param.crewSchdChangeId = params.assignEventResponse.crewSchdChangeId;
                        if (params.assignEventResponse.disableSendYes) {
                          param.disableSendYes = "false";
                        }
                        else {
                          param.disableSendYes = "true";
                        }
                        param.pushNotificationMessage=params.assignEventResponse.pushNotificationMessage;
                        PopupManager.openModal('SEND_CHANGE_NOTIFICATION',param);
                      }

                        function callListUpdateEvent(){
                        	angular.element(".right-section").scrollTop(vm.scrollTopPosition);
                			angular.element(".right-section").scrollLeft(vm.scrollLeftPosition);
                        }

                    } else if (!!params.assignEventResponse.adaptedRegulationMap) {
                        var regulationDetailParam = {
                            regulationMap: params.assignEventResponse.adaptedRegulationMap,
                            onAcceptPassBackParam: params
                        };
                        PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam, onCloseRegulationPopupForEvents);
                    }
                }
                else{
                  $timeout(function() {
                    angular.element(".right-section").scrollTop(vm.scrollTopPosition + 10);
                    angular.element(".right-section").scrollLeft(vm.scrollLeftPosition);
                  }, 1000);
                }
            }

            function onCloseRegulationPopupForEvents(params) {
                if (!!params) {
                    var isContinueIllegal = false;
                    var isUserConfirm = true;
                    CrewingHelper.assignEditEvent(params.assignEventRequestParam, isContinueIllegal, isUserConfirm,null,null,
                        function (assignEventData) {
                            if (assignEventData.success) {
                                MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_EVENT_SUCCESS);
                                updateSelectedCrew([params.assignEventRequestParam.crewId],callListUpdateEvent);

                              if (assignEventData.overlapped === "Y") {
                                var details = {
                                  title: 'Duty Overlapping',
                                  messages: [MessageService.MESSAGES.CREWING.DUTY_OVERLAPPING]
                                };
                                EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
                                PopupManager.openModal('CONFIRM_OVERLAP', details, confirmReplacingPattern);

                                function confirmReplacingPattern(param) {
                                  if (param === "SWAP") {
                                    CrewingHelper.replacePatternWithOverlapped(
                                      assignEventData.overlappedDuties,
                                      null,
                                      assignEventData.crewProfileId,
                                      assignEventData.crewSchdChangeId,
                                      function (response) {
                                        if (response != null) {
                                          loadActualSchedule(false, undefined, 'Y');
                                        }
                                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.RESET_SELECTED_CREW_AND_DAYS);
                                        if (assignEventData.sendCrewNotification === "Y") {
                                          var param = {};
                                          param.message = assignEventData.message;
                                          param.profileId = assignEventData.crewProfileId;
                                          param.user = assignEventData.user;
                                          param.telephone = assignEventData.telephone;
                                          param.crewSchdChangeId = assignEventData.crewSchdChangeId;
                                          if (assignEventData.disableSendYes) {
                                            param.disableSendYes = "false";
                                          }
                                          else {
                                            param.disableSendYes = "true";
                                          }
                                          param.pushNotificationMessage=assignEventData.pushNotificationMessage;
                                          PopupManager.openModal('SEND_CHANGE_NOTIFICATION', param);
                                        }
                                      },
                                      function (msg) {

                                      });
                                  } else {
                                    if (assignEventData.sendCrewNotification === "Y") {
                                      var param = {};
                                      param.message = assignEventData.message;
                                      param.profileId = assignEventData.crewProfileId;
                                      param.user = assignEventData.user;
                                      param.telephone = assignEventData.telephone;
                                      param.crewSchdChangeId = assignEventData.crewSchdChangeId;
                                      if (assignEventData.disableSendYes) {
                                        param.disableSendYes = "false";
                                      }
                                      else {
                                        param.disableSendYes = "true";
                                      }
                                      param.pushNotificationMessage=assignEventData.pushNotificationMessage;
                                      PopupManager.openModal('SEND_CHANGE_NOTIFICATION', param);
                                    }
                                  }
                                }
                              }
                              else if(assignEventData.sendCrewNotification === "Y"){
                                var param ={};
                                param.message=assignEventData.message;
                                param.profileId= assignEventData.crewProfileId;
                                param.user = assignEventData.user;
                                param.telephone = assignEventData.telephone;
                                param.crewSchdChangeId = assignEventData.crewSchdChangeId;
                                if (assignEventData.disableSendYes) {
                                  param.disableSendYes = "false";
                                }
                                else {
                                  param.disableSendYes = "true";
                                }
                                param.pushNotificationMessage=assignEventData.pushNotificationMessage;
                                PopupManager.openModal('SEND_CHANGE_NOTIFICATION',param);
                              }
                            }

                            function callListUpdateEvent(){
                            	angular.element(".right-section").scrollTop(vm.scrollTopPosition);
                    			angular.element(".right-section").scrollLeft(vm.scrollLeftPosition);
                            }
                        },
                        function (msg) {
                            MessageService.error(msg);
                        }
                    );
                }
            }
        }

        function getBlockDetail(param) {
            CrewingHelper.getBlockDetail(
                param.duty.blockId,
                param.duty.crewScheduleBlockId,
                !!param.duty.patternId,
                function (blockDetails) {
                    blockDetails.crewScheduleBlockId = param.duty.crewScheduleBlockId;
                    blockDetails.patternId = param.duty.patternId;
                    blockDetails.crewProfileId = param.crew.crewDTO.crewProfileId;
                    blockDetails.container = param.container;
                    blockDetails.crew = param.crew;
                    blockDetailResponseActions(blockDetails);
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }

        function blockDetailResponseActions(blockDetails) {
            switch (blockDetails.blockType) {
                case  'FLIGHT' :
                {
                    SlideInPanelService.openPanel(vm.rightPanelName, blockDetails);
                    break;
                }
                case 'TRAINING' :
                {
                    blockDetails.isTraining = true;
                    SlideInPanelService.openPanel(vm.rightPanelName, blockDetails);
                    break;
                }
                case 'EVENT' :
                {
                    CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
                        var appParamsEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
                        var param = {
                            day: '',
                            crew: blockDetails.crew,
                            isEditMode: true,
                            eventDetails: blockDetails,
                            container: blockDetails.container
                        };

                        param.showInCrewPortalParams = {
                            isVisible: appParamsEnable,
                            isEnabled: appParamsEnable && vm.model.isSchedulePublish,
                            value: vm.model.isSchedulePublish ? false : true
                        };
                        addEditEvent(param);
                    });
                    break;
                }
            }
        }

        function isCrewTypeSet() {
            return vm.model.searchParam.crewType!=="";
        }


        function onSendAlertClose(crewId) {
            if (!!crewId) {
                updateSelectedCrew([crewId])
            }
        }

        function crewScheduleCheckByCrewType(crewSchedule) {
            var cts = _.uniq(_.pluck(crewSchedule.schedule, 'crewType'));
            angular.forEach(cts, function (crewSH) {
                isCrewSchedulePublished(crewSH);
            });
        }

      function crewScheduleCheckByCrewProfileId(crewSchedule) {
        var crewProfileIds = crewSchedule.schedule.map(function(item) {
          return item.crewDTO.crewProfileId;
        });
        isCrewSchedulePublishedForCrewProfileId(crewProfileIds);
      }

      function doCrewScheduleSearch(searchParam, isAppend, isSetSearchPanel) {
            if (!!searchParam) {
              if(searchParam.crewIds != ""){
                vm.model.crewIds = searchParam.crewIds.split(",");
              }else{
                vm.model.crewIds = [];
              }
                searchParam.pageSize = vm.model.viewMode == "W" ? vm.model.recordsPerPage : 25;
                CrewingHelper.searchCrewSchedule(searchParam,
                    function (crewSchedule) {
	                	var timeLineData = CrewingSelectionHelper.getTimeLineDaysCol();
	                	vm.model.crewDTOs = [];
	                	for(var i=0; i < crewSchedule.schedule.length; i++) {
	                		crewSchedule.schedule[i].timeLineData = angular.copy(timeLineData);
	                		crewSchedule.schedule[i].crewDTO.flyingDuration = parseFloat((crewSchedule.schedule[i].crewDTO.flyingDuration/60).toFixed(2));
	                		crewSchedule.schedule[i].crewDTO.targetDuration = parseFloat((crewSchedule.schedule[i].crewDTO.targetDuration/60).toFixed(2));
	                		vm.model.crewDTOs.push(crewSchedule.schedule[i].crewDTO);
	                	}
                        if (!!isAppend) {
                            CrewingHelper.appendToCrewSchedule(vm.model.crewSchedule, crewSchedule);
                        } else {
                            EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, true);
                            $timeout(function (d) {
                                vm.model.crewSchedule = crewSchedule;
                                vm.model.isSearchPanelOpen = false;
                                CrewingHelper.setCrewScheduleData(vm.model.crewSchedule);
                                CrewingHelper.scrollToTopCrewSchedule();
                                if(!!isSetSearchPanel){
                                	EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.CREW_IDS_CHANGED,
                                			{ fromDate: searchParam.fromDate, crewIds : searchParam.crewIds});
                                }
                                  crewScheduleCheckByCrewProfileId(crewSchedule);

                            }, 1000)

                        }
                    },
                    function (error) {
                        MessageService.error(error);
                    }, true
                );
            }
        }


        function getTrackingTimeZone() {
            CrewingHelper.getTimeZoneText(
                function (timeZoneResponse) {
                    vm.model.timeZoneText = timeZoneResponse.message;
                    getCurrentTime(timeZoneResponse.timeZone);
                },
                function (error) {
                    console.log(error);
                }
            );
        }

        function getCurrentTime(timeZone) {
            CommonMasterData.getCurrentTime(timeZone,
                function (response) {
                    var param = {
                        dateStr: response.localDate,
                        timeStr: response.localTime
                    };
                    vm.model.currentTime = param;
                },
                function (error) {
                    console.log(error);
                }
            )
        }

      function isCrewSchedulePublishedForCrewProfileId(crewProfileIds) {
        console.log(crewProfileIds);
        CrewingHelper.checkIsPublishedByCrewProfileId(
          crewProfileIds,
          vm.model.searchParam.fromDate,
          vm.model.searchParam.toDate,
          function (isPublished) {
            vm.model.isSchedulePublish = isPublished;
            CrewingHelper.setIsPublished(isPublished);
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.IS_CREW_SCHEDULE_PUBLISHED, isPublished);
          },
          function (error) {
            //MessageService.error(error);
          }
        );
      }

        function isCrewSchedulePublished(type) {
            var crewType = vm.model.searchParam.crewType;
            if(!angular.isUndefined(type)){
                vm.model.searchParam.crewType = type;
                crewType = vm.model.searchParam.crewType;
            }
            CrewingHelper.checkIsPublished(
                crewType,
                vm.model.searchParam.fromDate,
                vm.model.searchParam.toDate,
                function (isPublished) {
                    vm.model.isSchedulePublish = isPublished;
                    CrewingHelper.setIsPublished(isPublished);
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.IS_CREW_SCHEDULE_PUBLISHED, isPublished);
                },
                function (error) {
                    //MessageService.error(error);
                }
            );
        }

        function onUpdateCrewSchedule(response) {
            updateSelectedCrew(response);
        }

        function onReloadData(name) {
            if (name == vm.rightPanelName) {
                getBlockDetail(vm.model.getBlockDetailsParam);
            }
        }

        function onShowInCrewPortal() {
            hideOnCrewPortal(false);
        }

        function onHideInCrewPortal() {
            hideOnCrewPortal(true);
        }

        function hideOnCrewPortal(visibilityFlag) {

            var selection = CrewingSelectionHelper.getSelectedBlocks();

            var ignoreRest = function(events){
                return _.filter(events, function (event) {
                    if(event.type!=='REST'){
                        return event;
                    }
                });
            };

            var blocks = selection.reduce(function (flattern,block) {
                return (!!block.events)? flattern.concat(ignoreRest(block.events)) : flattern;
            },[]);

            var crewIds = blocks.map(function (block) {

                return block.crewInfo.crewId;
            });

            CrewingHelper.updateBlockVisibilityFlag(blocks,visibilityFlag, function () {
                updateSelectedCrew(crewIds);
                MessageService.success('Crew Portal Visibility flags successfully updated');
            });
        }

        function openMemoListener(memo) {
            var param = {};
            param.day = memo.memoDate;
            param.crewProfileId = memo.crewInfo.crewProfileId;
            param.crewId = memo.crewInfo.crewId;
            param.memo = memo;
            param.readOnly= (memo.memoCategoryCode=='RECENCY')?true:false;
            param.status = true;
            // param.readOnly= true;
            var arr = vm.model.crewSchedule.schedule;
            for(let i = 0; i < arr.length; i++){
              if(memo.crewInfo.crewId === arr[i].crewDTO.crewId){
                param.batch = arr[i].crewDTO.crewBatch;
                param.group = arr[i].crewDTO.crewGroup;
              }
            }

            PopupManager.openModal('ADD_EDIT_MEMO', param, onAddMemoClose);
        }

        function publishCrewSchedule(param) {
            if (!!param) {
                CrewingHelper.schedulePublish(
                    vm.model.searchParam.crewType,
                    vm.model.searchParam.fromDate,
                    vm.model.searchParam.toDate,
                    function (data) {
                        if(data.publish) {
                          MessageService.success(MessageService.MESSAGES.CREWING.SCHEDULE_PUBLISHED_SUCCESS);
                          //noinspection JSUnresolvedFunction
                          vm.model.isSchedulePublish = true;
                          EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.IS_CREW_SCHEDULE_PUBLISHED, data.publish);
                          isCrewSchedulePublished(vm.model.searchParam.crewType);
                        }else{
                          if(data.publishSheduleRanges.length > 0) {
                            MessageService.error("Publish schedule overlapping in"+ getOverlapRangeString(data.publishSheduleRanges));
                          }else{
                            MessageService.error("Publish schedule failed.");
                          }
                        }
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                );
            }
        }

        function getOverlapRangeString(ranges) {
          var overlapString = "";
          angular.forEach(ranges, function(range) {
            overlapString += " ["+range.startDateStr+" to "+range.endDateStr+"] ";
          });
          return overlapString;
        }

        function onToolbarPublishListener() {
            var message = "Schedules from " + vm.model.searchParam.fromDate + " to " + vm.model.searchParam.toDate + " for Crew Type " + vm.model.searchParam.crewType + " will be Published. Do you wish to continue?";
            var details = {
                title: 'Confirmation',
                messages: [message]

            };
            PopupManager.openModal('CONFIRM_DIALOG', details, publishCrewSchedule);
        }

        function onShowCrewFilterListener(param) {
            var modalParam = {
                day: param.items.day,
                lastFilter: vm.model.filterSearchParam
            };
            PopupManager.closeModal('CREW_FILTER');
            PopupManager.openModal('CREW_FILTER', modalParam, onCrewFilterClose);
        }

        function onCrewFilterClose(param) {

            if (!!param) {
              if (param.airports.length == 0 && param.events.length == 0 &&
                param.flights.length == 0 && param.leaves.length == 0 ){
                vm.model.searchParam.crewIds = "";
                param.searchParams = vm.model.searchParam;
                vm.model.filterSearchParam.destinations=[];
                vm.model.filterSearchParam.events=[];
                vm.model.filterSearchParam.flightNumbers=[];
                vm.model.filterSearchParam.leaves=[];
                doCrewScheduleSearch(vm.model.searchParam);
                vm.model.isFilterActive = false;
              }else{
                param.searchParams = vm.model.searchParam;
                param.crewIds = [];
                CrewingHelper.dofilterCrewSchedule(param,
                  function (crewIds, filterCriteria) {
                    if (crewIds.length > 0) {
                      vm.model.crewSchedule = [];
                      vm.model.searchParam.startPosition = 1;
                      vm.model.searchParam.crewIds =crewIds;
                      vm.model.filterSearchParam = filterCriteria;
                      doCrewScheduleSearch(vm.model.searchParam);
                      vm.model.isFilterActive = true;
                    } else {
                      vm.model.isFilterActive = false;
                      MessageService.error(MessageService.MESSAGES.CREWING.NO_RESULT_FOR_FILTER);
                    }
                  },
                  function (error) {
                    MessageService.error(error);
                  });
              }

            }
        }

        function onAddMemoClose(param) {
            if (!!param) {
                updateSelectedCrew([param.crewId]);
            }
        }

      vm.checkManagementCrew = function(){
           console.log(vm.model.crewCategory);
        if(vm.model.crewCategory.description=='Trainer'){
          return true;
        }
        return false;
      };

      vm.onSearchClick = function () {
        var commaSeperatedCrewIds = "";
        if (Array.isArray(vm.model.crewIds)) {
          angular.forEach(vm.model.crewIds, function (crew) {
            if (crew.crewId != undefined) {
              commaSeperatedCrewIds += crew.crewId + ",";
            }
          })
        }
        if (commaSeperatedCrewIds != "") {
          commaSeperatedCrewIds = commaSeperatedCrewIds.substring(0, commaSeperatedCrewIds.length - 1);
        }
        if (vm.model.crewType == "") {
          var inputCrewId = angular.element("#crewIds input").val();
          if (inputCrewId != "") {
            if (inputCrewId.indexOf('(') > -1) {
              commaSeperatedCrewIds = inputCrewId.substring(inputCrewId.indexOf('(') + 1, inputCrewId.length - 1);
            } else {
              commaSeperatedCrewIds = inputCrewId;
            }
          }
        }
        vm.model.crewIds = commaSeperatedCrewIds;
        vm.onSearchSchedule({'searchParam': vm.model});

      };

        function getOpenPairings(openPairingParam, showLoading) {
            if (!!showLoading) {
                showHideOpenPairingLoading(true);
            }
            CrewingHelper.searchOpenPairings(openPairingParam,
                function (openPairings) {
                    showHideOpenPairingLoading(false);
                    vm.model.openPairings = openPairings;
                },
                function () {
                    showHideOpenPairingLoading(false);
                    console.log('Open pairing retrieval error');
                }
            );
        }


        function repositionSelectedOpenParing(paring) {
            var index = _.findIndex(vm.model.openPairings.openBlocks[paring.patternStartDate], {patternId: paring.patternId});
            if (index >= 0) {
                vm.model.openPairings.openBlocks[paring.patternStartDate].splice(index, 1);
                var tmp = angular.copy(paring);
                vm.model.openPairings.openBlocks[paring.patternStartDate].push(tmp);
            }
        }

        function removeSelectedOpenParing(paring) {
            var index = _.findIndex(vm.model.openPairings.openBlocks[paring.patternStartDate], {patternId: paring.patternId});
            if (index >= 0) {
                vm.model.openPairings.openBlocks[paring.patternStartDate].splice(index, 1);
            }
        }

        function showHideOpenPairingLoading(isLoadingVisible) {
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
                flag: isLoadingVisible,
                target: 'openPairingLoading',
                animationName: 'crewing-loader'
            });
        }

        function isSwapIncludeTraining(responseMap) {
            var isTrainingInclude = false;
            for (var key in responseMap) {
                if (responseMap[key].type === 'TRAINING') {
                    isTrainingInclude = true;
                    break;
                }
            }
            return isTrainingInclude;
        }

        function setIllegalFlags(data) {
            if(!!data.crewWiseRegulationMap){
                for (var key in data.crewWiseRegulationMap) {
                    data['legal']=true;
                    if (data.crewWiseRegulationMap[key]['conflictsExist']) {
                        data['conflictsExist'] = data.crewWiseRegulationMap[key]['conflictsExist'];
                        break;
                    }
                    if (!data.crewWiseRegulationMap[key]['legal']) {
                        data['legal'] = data.crewWiseRegulationMap[key]['legal'];
                        break;
                    }
                    if (data.crewWiseRegulationMap[key]['expiryWarnExist']) {
                        data['expiryWarnExist'] = data.crewWiseRegulationMap[key]['expiryWarnExist'];
                        data['daysBeforeExpiry'] = data.crewWiseRegulationMap[key]['daysBeforeExpiry'];
                        break;
                    }
                }
            }
            return data;
        }

        function getRegulationAfterSwap(responseMap) {
            for (var key in responseMap) {
                if (responseMap[key].type === 'TRAINING') {
                    return responseMap[key].regulationMap;
                    break;
                }
            }
        }

        function getRegulationUserResponse(data, isShowInPortal) {
            if (data.success) {
                resetSwapFlags();
                updateSelectedCrew(getCrewIdsFromBlocks([data.duties.firstDuty, data.duties.secondDuty]));
            }
            else if (!!data.crewWiseRegulationMap) {
                var expiryMsg = CrewingHelper.isSwapExpiryMessage(data.crewWiseRegulationMap);
                if (expiryMsg.length > 0) {
                    var param = {
                        title: 'Confirmation',
                        messages: expiryMsg,
                        isShowInPortal: isShowInPortal
                    };
                    PopupManager.openModal('CONFIRM_DIALOG', param, onSwapConfirmExpiryWarningsClose);
                } else {
                    var regulationDetailParam = {
                        regulationMap: data.crewWiseRegulationMap,
                        onAcceptPassBackParam: {
                            firstDuty: data.duties.firstDuty,
                            secondDuty: data.duties.secondDuty,
                            isShowInPortal:isShowInPortal
                        },
                        withGrouping: true,
                        isShowInPortal:isShowInPortal
                    };
                    PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam, onSwapRegulationClose);
                }
            }
        }

        function performSwapOperation(duties, isUserConfirm, isIgnoreExpiry, isShowInPortal) {
            var checkRegulationSuccess = function (map) {
                var send=true;
                for(var key in map){
                    if(!map[key].success){
                        send=false;
                        break;
                    }
                }
                return send;
            };

            var firstDuty = duties.firstDuty;
            var secondDuty = duties.secondDuty;
            if(angular.isUndefined(isShowInPortal)){
                isShowInPortal = angular.isUndefined(duties.isShowInPortal)?false:duties.isShowInPortal;
            }
            var swapCrewDTOs = [];
            for(var i=0; i < vm.model.crewDTOs.length; i++) {
                 if(vm.model.crewDTOs[i].crewProfileId == firstDuty.crewInfo.crewProfileId || vm.model.crewDTOs[i].crewProfileId == secondDuty.crewInfo.crewProfileId){
                    swapCrewDTOs.push(vm.model.crewDTOs[i]);
                }
            }
            CrewingHelper.swap(firstDuty, secondDuty,swapCrewDTOs,
                function (data) {
                    data.duties = duties;
                    if (data.success) {
                        resetSwapFlags();
                        updateSelectedCrew(getCrewIdsFromBlocks([firstDuty, secondDuty]), setSelectedCrewAfterSWAP);
                    }
                    if (isSwapIncludeTraining(data.responseMap)) {
                        data.adaptedRegulationMap = CrewingAdaptor.getRegulationMap(data.crewWiseRegulationMap); //data.crewWiseRegulationMap[0].adaptedRegulationMap;
                        data = setIllegalFlags(data);
                        CrewingHelper.assignTrainingActionList(duties, data, vm.model.swapFlags, performSwapOperation, getRegulationUserResponse, cancelCallBack, isShowInPortal)
                    }
                    else if (!!data.crewWiseRegulationMap && !checkRegulationSuccess(data.crewWiseRegulationMap)) {
                        getRegulationUserResponse(data, isShowInPortal);
                    }
                },
                function (msg) {
                    resetSwapFlags();
                    MessageService.error(msg);
                },
                isUserConfirm,
                isIgnoreExpiry,
                isShowInPortal
            );
        }

        function onSwapRegulationClose(param) {
            if (!!param) {
                vm.model.swapFlags.isUserConfirm = true;
                var duties = {
                    'firstDuty': param.firstDuty,
                    'secondDuty': param.secondDuty
                };
                performSwapOperation(duties, vm.model.swapFlags.isUserConfirm, vm.model.swapFlags.isIgnoreExpiry, param.isShowInPortal);
            }
        }

        function onSwapConfirmExpiryWarningsClose(param) {
            if (!!param) {
                vm.model.swapFlags.isIgnoreExpiry = true;
                var duties = {
                    'firstDuty': param.firstDuty,
                    'secondDuty': param.secondDuty
                };
                performSwapOperation(duties, vm.model.swapFlags.isUserConfirm, vm.model.swapFlags.isIgnoreExpiry, param.isShowInPortal);
            }
        }

        function performPasteForCutOperation(pasteActionParam) {
            var cutPasteCrewDTOs = [];
            for(var i=0; i < vm.model.crewDTOs.length; i++) {
              if(vm.model.crewDTOs[i].crewProfileId == pasteActionParam.cutCrewProfileId || vm.model.crewDTOs[i].crewProfileId == pasteActionParam.pasteCrewProfileId){
                cutPasteCrewDTOs.push(vm.model.crewDTOs[i]);
              }
            }
            vm.model.cutPasteRequest = {
                cutCrewProfileId: pasteActionParam.cutCrewProfileId,
                crewScheduleBlockId: pasteActionParam.crewScheduleBlockId,
                pasteCrewProfileId: pasteActionParam.pasteCrewProfileId,
                pasteCrewType: pasteActionParam.pasteCrewProfileId,
                userConfirm: false,
                ignoreExpiry: false,
                isShowInPortal: pasteActionParam.isShowInPortal,
                crewDTOs: cutPasteCrewDTOs
            };
            vm.model.cutPastCrewList = pasteActionParam.crewIds;
            vm.model.isMultipleCopy = false;
            cutPasteDuty(vm.model.cutPasteRequest);
        }

        function performPasteForCopyOperation(pasteActionParam) {
            var copyPasteCrewDTOs = [];
            for(var i=0; i < vm.model.crewDTOs.length; i++) {
              if(vm.model.crewDTOs[i].crewProfileId == pasteActionParam.crewProfileId){
                copyPasteCrewDTOs.push(vm.model.crewDTOs[i]);
              }
            }
            vm.model.copyPasteRequest = {
                crewScheduleBlockId: pasteActionParam.crewScheduleBlockId,
                crewProfileId: pasteActionParam.crewProfileId,
                crewType: pasteActionParam.crewType,
                userConfirm: false,
                ignoreExpiry: false,
                isShowInPortal: pasteActionParam.isShowInPortal,
                crewDTOs: copyPasteCrewDTOs
            };
            vm.model.copyPastCrewList = pasteActionParam.crewIds;
            vm.model.isMultipleCopy = false;
            copyPasteDuty(vm.model.copyPasteRequest);
        }

        function performPasteForMultipleCopyOperation(pasteActionParam, index) {
          var csBlocks = pasteActionParam.crewScheduleBlocks;
          var crewDTO = pasteActionParam.crewDTO;
          var requestList = generateCopyPasteRequestList(csBlocks, crewDTO);

          vm.model.copyPastCrewList = pasteActionParam.crewIds;
          vm.model.copyPasteRequestList = requestList;
          vm.model.currentCopyIndex = index;
          vm.model.isMultipleCopy = true;

          copyPasteDuty(requestList[index]);
        }

        function performNextPasteForMultipleCopyOperation(){
          if(vm.model.isMultipleCopy) {
            var requestList = vm.model.copyPasteRequestList;
            var nextIndex = vm.model.currentCopyIndex + 1;

            if (nextIndex < requestList.length) {
              copyPasteDuty(requestList[nextIndex]);
            }
            vm.model.currentCopyIndex = nextIndex;
          }
        }

        function generateCopyPasteRequestList(duties, crewDTO){
          var requestList = [];

          for(var i=0; i<duties.length; i++) {
            var duty = duties[i];
            requestList.push({
              crewScheduleBlockId: duty.crewScheduleBlockId,
              crewProfileId: crewDTO.crewProfileId,
              crewType: crewDTO.crewTypeCode,
              userConfirm: false,
              ignoreExpiry: false,
              isShowInPortal: duty.showInCrewPortal
            });
          }

          return requestList;
        }

        function cutPasteDuty(params, flags) {
            if (!angular.isUndefined(flags)) {
                params.userConfirm = flags.isUserConfirm;
                params.ignoreExpiry = flags.isIgnoreExpiries;
            }

            CrewingHelper.cutPasteDuty(params,
                function (response) {
                    if (!!response) {
                        if (response.type == 'TRAINING') {
                            vm.model.cutPastTrainingFlags = CrewingHelper.getAssignTrainingFlags();
                            CrewingHelper.assignTrainingActionList(params, response, vm.model.cutPastTrainingFlags, cutPasteDuty, cutPastSuccessCallBack, cancelCallBack, params.isShowInPortal);
                        } else if (response.type == 'DUTY') {
                            if (response.success) {
                                MessageService.success(MessageService.MESSAGES.CREWING.DUTY_MOVE_SUCCESS);
                                updateSelectedCrew(vm.model.cutPastCrewList);
                            } else {
                                var regulationDetailParam = {
                                    regulationMap: response.adaptedRegulationMap,
                                    onAcceptPassBackParam: {},//Dummy Object to check the confirm click
                                    isShowInPortal: params.isShowInPortal
                                };
                                PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam, onCutPastRegulationsClose);
                            }
                        }
                    }
                },
                function (msg) {
                    MessageService.error(msg);
                    updateSelectedCrew(vm.model.cutPastCrewList);
                });
        }

        function copyPasteDuty(params, flags) {
            if (!angular.isUndefined(flags)) {
                params.userConfirm = flags.isUserConfirm;
                params.ignoreExpiry = flags.isIgnoreExpiries;
            }
            CrewingHelper.copyPasteDuty(params,
                function (response) {
                    if (!!response) {
                        if (response.type == 'TRAINING') {
                            vm.model.copyPastTrainingFlags = CrewingHelper.getAssignTrainingFlags();
                            CrewingHelper.assignTrainingActionList(params, response, vm.model.copyPastTrainingFlags, copyPasteDuty, copyPasteSuccessCallback, cancelCallBack, params.isShowInPortal);
                        } else if (response.type == 'DUTY') {
                            if (response.success) {
                                MessageService.success(MessageService.MESSAGES.CREWING.DUTY_COPY_SUCCESS);
                                updateSelectedCrew(vm.model.copyPastCrewList);
                            } else {
                                var regulationDetailParam = {
                                    regulationMap: response.adaptedRegulationMap,
                                    onAcceptPassBackParam: params,//Dummy Object to check the confirm click
                                    isShowInPortal: params.isShowInPortal
                                };
                                PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam, onCopyPasteRegulationClose);
                            }
                        }
                        //copy the next duty if user click 'Yes' for regulation violation on multiple duty copy-paste
                        if(response.success){
                            performNextPasteForMultipleCopyOperation();
                        }
                    }
                },
                function (msg) {
                    MessageService.error(msg);
                }
            )
        }

        function cancelCallBack(){

        }


        function onCutPastRegulationsClose(param) {
            if (!!param) {
                cutPasteDuty(vm.model.cutPasteRequest, {isUserConfirm: true});
            } else if (vm.model.isBlockDrop) {
                updateSelectedCrew(vm.model.cutPastCrewList);
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.RESET_SELECTED_CREW_AND_DAYS);
            }
        }

        function onCopyPasteRegulationClose(param) {
            if (!!param) {
                copyPasteDuty(param, {isUserConfirm: true});
            } else {
              //copy the next duty if user click 'No' for regulation violation on multiple duty copy-paste
              performNextPasteForMultipleCopyOperation();
            }
        }

        function copyPasteSuccessCallback() {
            if (!!vm.model.copyPastCrewList) {
                updateSelectedCrew(vm.model.copyPastCrewList);
            }
        }

        function cutPastSuccessCallBack() {
            if (!!vm.model.cutPastCrewList) {
                updateSelectedCrew(vm.model.cutPastCrewList);
            }
        }

        function viewModeChangeListener(data) {
            if (data.view == vm.view) {
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, true);
                $timeout(function () {
                    vm.model.viewMode = data.mode;
                }, 0);
            }
        }

        function getNextSetOfRecords(isLoadingEnable) {
            if (vm.model.crewSchedule &&
                vm.model.crewSchedule.totalRecords &&
                vm.model.searchParam.startPosition + vm.model.searchParam.pageSize < vm.model.crewSchedule.totalRecords
            ) {
                vm.model.searchParam.startPosition = vm.model.searchParam.startPosition + vm.model.searchParam.pageSize;
                vm.model.searchParam.pageSize = vm.model.viewMode == "W" ? 54 : 25;
                getDataForElasticSearch(vm.model.searchParam,isLoadingEnable);
            } else {
                var lastPageStartPos = vm.model.crewSchedule.totalRecords - vm.model.searchParam.pageSize;
                if (vm.model.searchParam.startPosition < lastPageStartPos) {
                    vm.model.searchParam.startPosition = lastPageStartPos;
                    getDataForElasticSearch(vm.model.searchParam,isLoadingEnable);
                } else {
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.LAST_RECORD_REACHED);
                }
            }
        }

        /*angular.element(document.querySelector('.right-section')).bind('scroll', function(){
        	$scope.$broadcast('toggleWatchers', false);
        	$timeout(function(){
        		$scope.$broadcast('toggleWatchers', true);
        	});
          })*/

        function getDataForElasticSearch(params,isLoadingEnable) {
            if(angular.isUndefined(isLoadingEnable)){
                isLoadingEnable = true;
            }

            if(!!isLoadingEnable){
                showHideElasticSearchLoading(true);
            }else{
                showHideElasticSearchLoading(false);
            }

            CrewingHelper.searchCrewSchedule(params,
                function (newCrewSchedule) {
	            	var timeLineData = CrewingSelectionHelper.getTimeLineDaysCol();
	            	for(var i=0; i < newCrewSchedule.schedule.length; i++) {
	            		newCrewSchedule.schedule[i].timeLineData = angular.copy(timeLineData);
	            	}
                    CrewingHelper.appendToCrewSchedule(vm.model.crewSchedule, newCrewSchedule);
                    vm.model.isMoreRecordsAvailable = true;
                    showHideElasticSearchLoading(false);
                },
                function () {
                    vm.model.isMoreRecordsAvailable = false;
                    showHideElasticSearchLoading(false);
                },
                false
            );
        }

        function onRefreshCrewScheduleListener() {
            /*to avoid wrong crew type send for search schedule*/
            if(!vm.model.searchParam.crewIds == ""){
                vm.model.searchParam.crewType ="";
            }

            if (vm.model.isShowAllCrewsForBlockActive) {
                var clone = angular.copy(vm.model.searchParam);
                var pages = clone.pageSize * ( Math.round(clone.startPosition / clone.pageSize) + 1);
                clone.pageSize = pages;
                clone.startPosition = 1;
                doCrewScheduleSearch(clone);
            } else if (vm.model.isFilterActive) {
                vm.model.isFilterActive = false;
                vm.model.searchParam.crewIds = '';
                doCrewScheduleSearch(vm.model.searchParam);
            } else {
                vm.model.crewSchedule = [];
                vm.model.searchParam.startPosition = 1;
                doCrewScheduleSearch(vm.model.searchParam);
            }
            vm.model.isShowAllCrewsForBlockActive = false;
        }

        function showHideElasticSearchLoading(flag) {
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
                flag: flag,
                target: 'crewing',
                animationName: 'crewing-loader'
            });
        }


        function isWarningCheckApplicable(crewTypeMasterCode, patternType) {
            return crewTypeMasterCode == 'CC' && patternType == 'FLIGHT';
        }

        function assignPairingResponseActions(assignParingResponse) {
            if (!!assignParingResponse) {
                if (!!assignParingResponse.regulationDetails.regulationMap) {
                    var regulationDetailParam = {
                        regulationMap: assignParingResponse.regulationDetails.adaptedRegulationMap,
                        onAcceptPassBackParam: assignParingResponse
                    };
                    PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam, onCloseRegulationPopupForPairing);
                } else {
                    var crewId = CrewingHelper.getCrewIdFromCrewProfileID(assignParingResponse.crewProfileId, vm.model.crewSchedule.nameCollection);
                    vm.scrollTopPosition = angular.element(".right-section").scrollTop();
                    vm.scrollLeftPosition = angular.element(".right-section").scrollLeft();

                    updateSelectedCrew([crewId]);
                    MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_PAIRING_SUCCESS);

                    if (assignParingResponse.otherBlockIllegal) {
                        MessageService.warning(MessageService.MESSAGES.CREWING.ASSIGN_TRAINING_OTHER_BLOCKS_ILLEGAL);
                    }

                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);

                    $timeout(function() {
                      angular.element(".right-section").scrollTop(vm.scrollTopPosition + 10);
                      angular.element(".right-section").scrollLeft(vm.scrollLeftPosition);
                    }, 1000);
                  var data = assignParingResponse.regulationDetails;
                  if(data.sendCrewNotification === "Y"){
                    var params ={};
                    params.message=data.message;
                    params.profileId= data.crewProfileId;
                    params.user = data.user;
                    params.telephone = data.telephone;
                    params.crewSchdChangeId = data.crewSchdChangeId;
                    if (data.disableSendYes) {
                      params.disableSendYes = "false";
                    }
                    else {
                      params.disableSendYes = "true";
                    }
                    params.pushNotificationMessage=data.pushNotificationMessage;
                    PopupManager.openModal('SEND_CHANGE_NOTIFICATION',params);
                  }
                }
            } else {
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
            }

            function onCloseRegulationPopupForPairing(params) {
                if (!!params) {
                  var violatedList = getOverridenViolations(params.regulationDetails.regulationMap);
                    CrewingHelper.assignPattern(
                        params.crewProfileId,
                        params.pattern,
                        params.isRequest,
                        params.isCallFromDayOff,
                        params.isObsFlight,
                        params.isHideinCrewPortal,
                        false,
                        true,
                        params.isShowCrewPortal,
                        null,
                        params.isComplementFilled,
                        params.isTargetHoursValid,
                        params.sbyCallOutDateTime,
                        null,
                        null,
                        null,
                        violatedList,
                        function (data) {
                            MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_PAIRING_SUCCESS);
                            if (data.otherBlockIllegal) {
                                MessageService.warning(MessageService.MESSAGES.CREWING.ASSIGN_TRAINING_OTHER_BLOCKS_ILLEGAL);
                            }
                            if (!!data) {
                                var crew = CrewingHelper.getCrewFromCrewProfileID(params.crewProfileId, vm.model.crewSchedule.nameCollection);
                                if (!!crew) {
                                    updateSelectedCrew([crew.crewId]);
                                    updateSelectedParing(params.pattern, crew.crewTypeCode);
                                }
                            }

                          if (data.overlapped === "Y") {

                            var details = {
                              title: 'Duty Overlapping',
                              messages: [MessageService.MESSAGES.CREWING.DUTY_OVERLAPPING]
                            };
                            EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
                            PopupManager.openModal('CONFIRM_OVERLAP', details, confirmReplacingPattern);

                            function confirmReplacingPattern(param) {
                              if (param === "SWAP") {
                                CrewingHelper.replacePatternWithOverlapped(
                                  data.overlappedDuties,
                                  params.pattern.patternId,
                                  data.crewProfileId,
                                  data.crewSchdChangeId,
                                  function (response) {
                                    if (response != null) {
                                      var crew = CrewingHelper.getCrewFromCrewProfileID(params.crewProfileId, vm.model.crewSchedule.nameCollection);
                                      if (!!crew) {
                                        updateSelectedCrew([crew.crewId]);
                                        updateSelectedParing(params.pattern, crew.crewTypeCode);
                                      }
                                    }
                                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.RESET_SELECTED_CREW_AND_DAYS);
                                    if(data.sendCrewNotification === "Y"){
                                      var param ={};
                                      param.message=data.message;
                                      param.profileId= data.crewProfileId;
                                      param.user = data.user;
                                      param.telephone = data.telephone;
                                      param.crewSchdChangeId = data.crewSchdChangeId;
                                      if (data.disableSendYes) {
                                        param.disableSendYes = "false";
                                      }
                                      else {
                                        param.disableSendYes = "true";
                                      }
                                      param.pushNotificationMessage=data.pushNotificationMessage;
                                      PopupManager.openModal('SEND_CHANGE_NOTIFICATION',param);
                                    }
                                  },
                                  function (msg) {

                                  });
                              }
                              else {
                                if(data.sendCrewNotification === "Y"){
                                  var param ={};
                                  param.message=data.message;
                                  param.profileId= data.crewProfileId;
                                  param.user = data.user;
                                  param.telephone = data.telephone;
                                  param.crewSchdChangeId = data.crewSchdChangeId;
                                  if (data.disableSendYes) {
                                    param.disableSendYes = "false";
                                  }
                                  else {
                                    param.disableSendYes = "true";
                                  }
                                  param.pushNotificationMessage=data.pushNotificationMessage;
                                  PopupManager.openModal('SEND_CHANGE_NOTIFICATION',param);
                                }
                              }
                            }
                          }
                          else {
                            if(data.sendCrewNotification === "Y"){
                              var param ={};
                              param.message=data.message;
                              param.profileId= data.crewProfileId;
                              param.user = data.user;
                              param.telephone = data.telephone;
                              param.crewSchdChangeId = data.crewSchdChangeId;
                              if (data.disableSendYes) {
                                param.disableSendYes = "false";
                              }
                              else {
                                param.disableSendYes = "true";
                              }
                              param.pushNotificationMessage=data.pushNotificationMessage;
                              PopupManager.openModal('SEND_CHANGE_NOTIFICATION',param);
                            }
                          }

                            EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
                        },
                        function (msg) {
                            MessageService.error(msg);
                        }
                    );
                } else {
                    repositionSelectedOpenParing(assignParingResponse.pattern);
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
                }
            }
        }

      function getOverridenViolations(regulationsMap) {
        var violatedRegulations = [];

        angular.forEach(regulationsMap, function (value, key) {
          console.log(key, value);
          angular.forEach(value, function (regulation) {
            if (!regulation.legalDay1 || !regulation.legalDay2) {
              violatedRegulations.push(regulation.regulationCode);
            }
          });
        });

        return violatedRegulations;
      }

        function updateSelectedParing(pairing, crewTypeCode) {
            CrewingHelper.isPairingOpen(pairing.patternId, crewTypeCode,
                function (isOpen) {
                    if (isOpen) {
                        repositionSelectedOpenParing(pairing)
                    } else {
                        removeSelectedOpenParing(pairing);
                    }
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }

        function getCrewIdsFromBlocks(blocks) {
            var ids = [];
            angular.forEach(blocks, function (block) {
                ids.push(block.crewInfo.crewId);
            });
            return ids;
        }

        function updateSelectedCrew(ids, afterUpdateCallBack) {
            var param = angular.copy(vm.model.searchParam);
            var tmpArr = ids || [];
            param.crewIds = tmpArr.toString();

            /*to avoid wrong crew type send for search schedule*/
            if(tmpArr.length != 0) {
              param.crewType = "";
            }

            param.startPosition = 1;
            CrewingHelper.searchCrewSchedule(param,
                function (updatedCrewSchedule) {
	            	var timeLineData = CrewingSelectionHelper.getTimeLineDaysCol();
	            	vm.model.crewDTOs = [];
	            	for(var i=0; i < updatedCrewSchedule.schedule.length; i++) {
	            		updatedCrewSchedule.schedule[i].timeLineData = angular.copy(timeLineData);
	            		updatedCrewSchedule.schedule[i].crewDTO.flyingDuration = parseFloat((updatedCrewSchedule.schedule[i].crewDTO.flyingDuration/60).toFixed(2));
                  updatedCrewSchedule.schedule[i].crewDTO.targetDuration = parseFloat((updatedCrewSchedule.schedule[i].crewDTO.targetDuration/60).toFixed(2));
                  vm.model.crewDTOs.push(updatedCrewSchedule.schedule[i].crewDTO);
	            	}
                    CrewingHelper.updateSelectedCrews(vm.model.crewSchedule, tmpArr, updatedCrewSchedule);
                    if(!angular.isUndefined(afterUpdateCallBack)){
                        afterUpdateCallBack(ids, updatedCrewSchedule);
                    }
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }

        function setSelectedCrewAfterSWAP(ids, crewSchedule) {
            var crewNames = "";
            angular.forEach(crewSchedule.nameCollection, function (crew) {
                var context = {
                    crews: crew
                };
                crewNames+= crew.name + '\n';
                CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.CREW, CrewingSelectionHelper.INTERACTION.CTRL_CLICK, context);
            });
            MessageService.success("Swap Operation successful \n" + crewNames);
        }

        function getCrewTypes() {
            CommonMasterData.getCrewTypeList(
                function (crewTypes) {
                    vm.model.crewTypes = crewTypes;
                },
                function () {
                    console.log('Crew type retrieval error');
                }
            );
        }

      function getManagementCrewPositionList(){
        CommonMasterData.getManagementCrewPositions(
          function (response) {
            vm.model.mgtPositions = response;
          },
          function () {
            console.log('Crew position retrieval error');
          }
        );
      };

        function getAircraftList() {
            CommonMasterData.getAircraftModels(
                function (aircrafts) {
                    vm.model.aircraftTypes = aircrafts;
                },
                function () {
                    console.log('Aircraft type retrieval error');
                }
            );
        }

        function getCrewBaseTypes() {
            CommonMasterData.getCrewBaseList(
                function (baseTypes) {
                    vm.model.crewBaseTypes = baseTypes;
                },
                function () {
                    console.log('Crew Base type retrieval error');
                }
            );
        }

        function getCrewGroups() {
            CommonMasterData.getCrewGroups(
                function (crewGroups) {
                    vm.model.crewGroups = CrewingAdaptor.crewGroupAdaptor(crewGroups);
                },
                function () {
                    console.log('Crew Groups retrieval error');
                }
            );
        }

        function getCrewPositions() {
            CommonMasterData.getCrewCategoryList(
                function (crewCategory) {
                    vm.model.crewCategory = CrewingAdaptor.crewCategoryAdaptor(crewCategory);
                },
                function () {
                    console.log('Crew Category retrieval error');
                }
            );
        }

        function getNationalityList() {
            CommonMasterData.getNationalityList(
                function (nationalities) {
                    vm.model.allNationalities = nationalities;
                },
                function () {
                    console.log('nationalities retrieval error');
                }
            );
        }

      function getCrewBatchList() {
        var param = {
          "description": "",
          "pageSize": -1,
          "startPosition": 1

        };
        CommonMasterData.getCrewBatchList(param,
          function (crewTypes) {
            vm.model.crewBatchList = crewTypes;
          },
          function () {
            console.log('Crew batch retrieval error');
          }
        );
      }

        function getLanguageList() {
            CommonMasterData.getLanguageList(
                function (languages) {
                    vm.model.allLanaguages = languages;
                },
                function () {
                    console.log('languages retrieval error');
                }
            );
        }

        function getCrewTypeMasterCodes() {
            CommonMasterData.getCrewTypeMasterCodes(
                function (crewTypeMasterCodes) {
                    vm.model.crewTypeMasterCodes = crewTypeMasterCodes;
                },
                function () {
                    console.log('crewTypeMasterCodes retrieval error');
                }
            );
        }

        function getCrewOperTypes(){
        	 CommonMasterData.crewOperTypes(
                 function (response) {
                    var newOperTypes = [];
                    var operTypeAll = {operTypeDesc: "All ",operTypeCode : "All"};
                     newOperTypes.push(operTypeAll);
                     angular.forEach(response, function (type) {
                    	 newOperTypes.push(type);
                      });
                     vm.model.crewOperTypes = newOperTypes;
                   }, function () {}
              );
        }

        function onFireUndoEvent() {
            CommonMasterData.undoAction(
                function (crewIds) {
                    updateSelectedCrew(crewIds, crewSelect);
                },
                function (error) {
                    MessageService.error(error);
                }
            );

        }

        function crewSelect(ids, crewSchedule) {
            var crewNames = "";
            CrewingSelectionHelper.clearSelections();
            angular.forEach(crewSchedule.nameCollection, function (crew) {
                var context = {
                    crews: crew
                };
                crewNames+= crew.name + '\n';
                CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.CREW, CrewingSelectionHelper.INTERACTION.CTRL_CLICK, context);
            });
            MessageService.success(MessageService.MESSAGES.COMMON.UNDO_SUCCESS + " " + crewNames);

        }
        //initial loading master data
        (
        		function(){
        			getCrewTypes();
              getAircraftList();
              getCrewBaseTypes();
              getCrewGroups();
              getCrewPositions();
              getCrewTypeMasterCodes();
              getNationalityList();
              getLanguageList();
              getCrewOperTypes();
              getCrewBatchList();
              getManagementCrewPositionList();
        		}
        )();
        handleNevigation();
    }
}());
